export const COLORS = {
  white: "#ffffff",
  black: "#000000",
  button: "#232323",
};
